export class Submission {
    idPerfilTIC?: number;
    experiencia!: string;
    sueldo!: number;
    sexo!: string;
    date!: string;
}
